import type { BoxProps } from '../box'
import type { ChangeEvent } from '../utils'

import Box from '../box'
import { useStyleConfig, vui } from '../core'
import T from '../t'
import TextField from '../textField'
import { cs } from '../utils'
import { usePaginationContext } from './context'

/** Displays a number input, which allows quickly jumping between pages. */
export const PaginationGoToPage = vui<'div', BoxProps>((props, ref) => {
  const { className, ...rest } = props
  const { onPageChange, pageCount } = usePaginationContext()
  const styles = useStyleConfig('Pagination', usePaginationContext())

  const onChange = (e: ChangeEvent) => {
    const value = +e.target.value
    if (value >= 1 && value <= pageCount) {
      onPageChange(Math.floor(value))
    } else if (value > pageCount) {
      onPageChange(pageCount)
    } else {
      onPageChange(1)
    }
  }

  return (
    <Box
      centerV
      className={cs('vui-paginationGoToPage', className)}
      lineHeight="normal"
      ref={ref}
      {...styles.goToPage}
      {...rest}
    >
      <T size="sm" variant="navigation" fontWeight="medium">
        Go&nbsp;to
      </T>
      <TextField max={pageCount} min={1} mx={1} onChange={onChange} size="sm" type="number" w={56} />
      <T size="sm" variant="navigation" fontWeight="medium">
        Page
      </T>
    </Box>
  )
})

PaginationGoToPage.displayName = 'PaginationGoToPage'

export default PaginationGoToPage
